export const SELECT_BODY_WEIGHT = 'SELECT_BODY_WEIGHT_BODY_CONDITION';
export const SELECT_GOAL_WEIGHT = 'SELECT_GOAL_WEIGHT_BODY_CONDITION';
export const DEFAULT = 'DEFAULT_BODY_CONDITION';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_BODY_CONDITION';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_BODY_CONDITION';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_BODY_CONDITION';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
